import { Table } from "reactstrap";
import { IIndividual, IIndividualAssignmentsResponse, IPositionAssignmentLight, IPositionBasedAssignmentsResponse } from "../../../../types/individual";
import { useLazyQuery, useQuery } from "@apollo/client";
import { INDIVIDUAL_ASSIGNMENTS, SEARCH_POSITION_BASED_ASSIGNMENT } from "../../../../graphql/individual-gql";
import SpinnerOverlay from "../../../common/spinner/spinner";
import OmsToolTip from "../../../common/oms-tooltip/oms-tooltip";
import { PauseIcon } from "../../../common/icons";
import { useEffect, useState } from "react";

type IndividualAssignmentsProp = {
    individual:IIndividual;
}

const IndividualAssignments:React.FC <IndividualAssignmentsProp> = ({individual}) => {
    const {loading,error,data} =  useQuery<IIndividualAssignmentsResponse>(
        INDIVIDUAL_ASSIGNMENTS,
        {variables:
            {individualId:individual.individualId},
            fetchPolicy:'network-only'
        },
    )
    //if(data) console.log("assignmentData:",data)

    const [getPositionBasedAssignments,{loading: positionBasedAssignmentsLoading }]= useLazyQuery<IPositionBasedAssignmentsResponse>(SEARCH_POSITION_BASED_ASSIGNMENT)
    const [ positionBasedAssignments, setPositionBasedAssignments] = useState<IPositionAssignmentLight[]>([])

    useEffect(() => {
        setPositionBasedAssignments([])
       // if (individual.assignmentType == 'Position Based') {
            getPositionBasedAssignments({ variables: { individualId: individual.individualId }, fetchPolicy: "network-only" }).then(res => {
                if (res.data?.searchPositionBasedIndividualAssignments) {
                    setPositionBasedAssignments(res.data?.searchPositionBasedIndividualAssignments)
                }
            }
            );

    }, [individual])


return(<>
        {(loading || positionBasedAssignmentsLoading) && <SpinnerOverlay/>}
        {( (data?.individualAssignments && data.individualAssignments.length>0) || (positionBasedAssignments && positionBasedAssignments.length > 0)) &&
            <Table striped className="assignments-table">
                <thead>
                    <tr>
                        <th style={{width:'16%'}}><div role="region" aria-label="Position or Role">Position or Role</div></th>
                        <th style={{width:'28%'}}><div role="region" aria-label="Title">Title</div></th>
                        <th style={{width:'28%'}}><div role="region" aria-label="Assignment Type">Assignment Type</div></th>
                        <th style={{width:'28%'}}><div role="region" aria-label="Organization/Group Name">Organization/Group Name</div></th>
                    </tr>
                </thead>
                <tbody>
                    {data?.individualAssignments?.map((assignment:IPositionAssignmentLight,index: number)=>(
                        <tr key={`assignment-${index}`}>
                            <td>{assignment.isRole?"Role":"Position"}</td>
                            <td>
                                <OmsToolTip positionId={assignment.positionId}>
                                        <u >{assignment.fullPositionName}</u>
                                </OmsToolTip>
                            </td>
                            <td>
                                <span hidden={assignment.isActive}><PauseIcon alt="Deactivate icon"/>&nbsp;</span>
                                {assignment.relationshipType}{assignment.acting&&" (Acting)"} {!assignment.isActive && " - Inactive"} {!assignment.isActive && assignment.deactivationReason && ` (${assignment.deactivationReason})`}
                            </td>
                            <td>

                                <OmsToolTip positionId={assignment.positionId}>
                                        <u >{assignment.relatedOrganization}</u>
                                </OmsToolTip>

                            </td>

                        </tr>

                    ))}
                    {positionBasedAssignments.map((assignment:IPositionAssignmentLight,index: number)=>(
                        <tr key={`assignment-${index}`}>
                            <td>{assignment.isRole?"Role":"Position"}</td>
                            <td>
                                <OmsToolTip positionId={assignment.positionId}>
                                        <u >{assignment.fullPositionName}</u>
                                </OmsToolTip>
                            </td>
                            <td>
                                {/* {<span hidden={assignment.isActive}><PauseIcon alt="Deactivate icon"/>&nbsp;</span> } */}
                                <span style={{ fontStyle:  'normal' }}>
                                    {assignment.relationshipType}

                                    {/* {(!assignment.isActive&&assignment.deactivationReason) && ` (${assignment.deactivationReason})`}  */}
                                </span>
                            </td>

                            <td>
                                <OmsToolTip positionId={assignment.positionId}>
                                        <u >{assignment.relatedOrganization}</u>
                                </OmsToolTip>
                            </td>

                        </tr>

                    ))}
                </tbody>
            </Table>

        }

    </>)
}

export default IndividualAssignments
